'use strict';

/**
 * Checks each `.blog-description-wrapper` element for text overflow
 * and toggles the visibility of the corresponding "Read More" button.
 *
 * Dynamically calculates the maximum visible height for blog descriptions
 * based on screen size (mobile vs. desktop). If a description exceeds the
 * allowed height, it limits the visible text and displays the "Read More"
 * control. Otherwise, the full description is shown and the button is hidden.
 *
 * The function runs on initial page load and re-checks after window resize
 * with a small debounce delay.
 */
function checkOverflow() {
    $('.blog-description-wrapper').each(function () {
        const $wrapper = $(this);
        const $desc = $wrapper.find('.blog-description');
        const $readMore = $wrapper.find('.read-more');

        const isMobile = window.innerWidth < 768;
        const lineHeight = isMobile ? 15 : 17;
        const maxLines = isMobile ? 5 : 2;
        const maxHeight = lineHeight * maxLines;

        // Reset height to measure accurately
        $desc.css('max-height', 'none');

        if ($desc[0].scrollHeight > maxHeight) {
            $readMore.removeClass('d-none').show();
            $desc.css('max-height', maxHeight + 'px');
        } else {
            $readMore.addClass('d-none').hide();
            $desc.css('max-height', 'none');
        }
    });
}

$(document).ready(function () {
    checkOverflow();

    let resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(checkOverflow, 300);
    });
});

module.exports = { checkOverflow };
